(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class DismissibleAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.storageKey = `announcement-bar-dismissed-${this.sectionId}`;
      this.closeButton = null;
    }

    connectedCallback() {
      // Check if this announcement bar was previously dismissed
      if (this.dataset.dismissible !== undefined) {
        if (sessionStorage.getItem(this.storageKey) === 'true') {
          this.hidden = true;
          this.dataset.loaded = 'true';
          return;
        }

        // Mark as loaded so CSS will show it
        this.dataset.loaded = 'true';
      }

      // Find and bind close button
      this.closeButton = this.querySelector('.announcement-bar__close');
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.dismiss());
      }
    }

    disconnectedCallback() {
      if (this.closeButton) {
        this.closeButton.removeEventListener('click', () => this.dismiss());
      }
    }

    dismiss() {
      // Store dismissal state in sessionStorage
      sessionStorage.setItem(this.storageKey, 'true');
      // Hide the announcement bar
      this.hidden = true;
    }
  }

  if (!customElements.get('dismissible-announcement-bar')) {
    customElements.define('dismissible-announcement-bar', DismissibleAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apc-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
